export default __webpack_public_path__ + "static/media/Electrolytes.30c706ac.svg";